export enum Fresh {
    NotDefined = 0,
    NonFresh = 1,
    Fresh = 2,
    UltraFresh = 3,
    All = 10,
}



// WEBPACK FOOTER //
// ./src/app/shared/models/fresh.ts